var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L19.29 15.79C19.92 16.42 21 15.97 21 15.08V8.91C21 8.02 19.92 7.57 19.29 8.2L17 10.5ZM13 13H11V15C11 15.55 10.55 16 10 16C9.45 16 9 15.55 9 15V13H7C6.45 13 6 12.55 6 12C6 11.45 6.45 11 7 11H9V9C9 8.45 9.45 8 10 8C10.55 8 11 8.45 11 9V11H13C13.55 11 14 11.45 14 12C14 12.55 13.55 13 13 13Z",
    fill: "#471EED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamPurple);
export default __webpack_public_path__ + "static/media/camPurple.524e7a97da2790119873318cfed09a05.svg";
export { ForwardRef as ReactComponent };